<template>
    <div class="history-box" v-if="state">
        <div class="popBox">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    <span v-if="cardInfo.card_type === '1'">[次卡]</span>{{cardInfo.title}}权益
                    <span class="fr" @click="close"><i class="el-icon-close"></i></span>
                </div>
                <div class="popBody" ref="popBody">
                    <div class="product-list">
                        <el-row class="ht">
                            <el-col :span="6">包含项目</el-col>
                            <el-col :span="6" class="tc">单价</el-col>
                            <el-col :span="6" class="tc">次数</el-col>
                            <el-col :span="6" class="tr">有效期</el-col>
                        </el-row>
                        <el-row class="list-line" v-for="(val, key) in listData" :key="key">
                            <el-col :span="6">
                                {{val.pro_title}}
                                <el-tag type="danger" effect="dark" size="mini" v-if="val.tag">{{val.tag}}</el-tag>
                            </el-col>
                            <el-col :span="6" class="tc">{{val.price}}</el-col>
                            <el-col :span="6" class="tc">
                                <span v-if="val.num > 0">{{val.num}}次</span>
                                <span v-else>无限</span>
                            </el-col>
                            <el-col :span="6" class="tr">
                                <span v-if="cardInfo.valid_day > 0">{{cardInfo.valid_day}}天</span>
                                <span v-else>永久有效</span>
                            </el-col>
                        </el-row>
                        <el-row class="list-total" v-if="cardInfo.count_type !== '2'">
                            <el-col :span="6">合计</el-col>
                            <el-col :span="6">&nbsp;</el-col>
                            <el-col :span="6" class="tc">{{totalNum}}次</el-col>
                            <el-col :span="6" class="tr">&nbsp;</el-col>
                        </el-row>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "CardEditHistoryProduct",
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: Boolean,
            cardInfo: Object
        },
        data: () => ({
            listData: [],
            totalNum: 0
        }),
        methods: {
            //初始化
            init: function () {
                this.$root.log(this.cardInfo);
                this.getCardProduct();
            },
            //加载权益项目
            getCardProduct: function () {
                obj.postData("card/get_edit_history_product", {history_id: this.cardInfo.id}, res => {
                    if(res.errcode === 0){
                        this.listData = res.data;
                    }else{
                        obj.messageBox.error(res.errdesc);
                    }
                });
            },
            //关闭
            close: function () {
                this.$emit("stateChange", false);
            }
        },
        watch: {
            state: function (val) {
                if(val) this.init();
            },
            listData: function (data) {
                this.totalNum = 0;
                if(data){
                    let num = 0;
                    data.forEach(val => {
                        num += Number(val.num);
                    });
                    this.totalNum = num;
                }
            }
        }
    }
</script>

<style scoped>
    .history-box{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        left: 0;
        top: 0;
        z-index: 99;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
    }
    .popBox{
        width: 992px;
        /*height: 630px;*/
        background-color: #ffffff;
        border-radius: 3px;
    }
    .popBox .title{
        font-size: 18px;
        color: #333333;
    }
    .popBox .popBody{
        padding: 0px 20px;
        height: 568px;
    }
    .popBody .text-desc{
        font-size: 14px;
        color: #333333;
        padding: 10px 0 20px;
    }
    .product-list{
        line-height: 40px;
    }
    .product-list .ht{
        height: 40px;
        line-height: 40px;
        background-color: #f4f4f4;
        padding: 0px 20px;
    }
    .product-list .list-line{
        border-bottom: 1px solid #ebedf0;
        padding: 0px 20px;
    }
    .product-list .list-total{
        padding: 0px 20px;
    }
</style>
